import { flow } from 'lodash'
import { getRootState } from 'store/shared'

export const getPeerReviewModuleRootState = flow(
  getRootState,
  (x) => x.modules.advisory.modules.teams.modules.peerReview
)
